// import { useState, useEffect, useContext, useCallback } from "react";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
// import MeetingForm from "./MeetingForm";
// import { FaEdit, FaSearch, FaTrash } from "react-icons/fa";
// import { Select } from "antd";

// export default function Meeting() {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [meetings, setMeetings] = useState([]);
//   const [showMeetingForm, setShowMeetingForm] = useState(false);
//   const [editingMeeting, setEditingMeeting] = useState(null);
//   const [activeTab, setActiveTab] = useState("assigned");
//   const [searchParams, setSearchParams] = useState({
//     targetUserId: "",
//     meetingType: "",
//     message: "",
//   });
//   const [isSearching, setIsSearching] = useState(false);
//   const [showFields, setShowFields] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [meetingToDelete, setMeetingToDelete] = useState(null);
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
//   const [expandedMessages, setExpandedMessages] = useState({});

//   const toggleMessageExpansion = (meetingId) => {
//     setExpandedMessages((prev) => ({
//       ...prev,
//       [meetingId]: !prev[meetingId],
//     }));
//   };

//   // Fetch meetings based on account type
//   const fetchMeetings = useCallback(async () => {
//     try {
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/meetings/company/${user.id}`
//           : activeTab === "assigned"
//           ? `${API_URL}/api/meetings/assigned/${user.id}`
//           : `${API_URL}/api/meetings/createdBy/${user.id}`;

//       const response = await axios.get(
//         `${url}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setMeetings(response.data?.meetings || []);
//       setTotalPages(response.data?.totalPages || 0);
//     } catch (error) {
//       console.error("Error fetching reminders:", error);
//       setMeetings([]);
//       setTotalPages(0);
//     }
//   }, [user, activeTab, pageNumber, pageSize]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchMeetings();
//     }
//   }, [user, activeTab, pageNumber, fetchMeetings]);

//   useEffect(() => {
//     const handleMeetingCreated = () => {
//       // Your data fetching logic here
//       fetchMeetings();
//     };

//     window.addEventListener("meetingCreated", handleMeetingCreated);

//     return () => {
//       window.removeEventListener("meetingCreated", handleMeetingCreated);
//     };
//   }, []);

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;

//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await axios.get(url, {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         setUsers(response.data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);

//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       const params = {
//         pageNumber: 0, // Always start from first page when searching
//         pageSize: pageSize,
//         ...Object.fromEntries(
//           Object.entries(searchParams).filter(([_, v]) => v !== "")
//         ),
//       };

//       const response = await axios.get(
//         `${API_URL}/api/meetings/search/${companyId}/${user?.id}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setMeetings(response.data?.meetings || []);
//       setTotalPages(response.data?.totalPages || 0);
//       setPageNumber(0); // Reset to first page after search
//     } catch (error) {
//       console.error("Failed to search meetings:", error);
//       setMeetings([]);
//       setTotalPages(0);
//     }
//   };

//   const handleClearSearch = async () => {
//     setIsSearching(false);
//     setSearchParams({
//       targetUserId: "",
//       meetingType: "",
//       message: "",
//     });
//     setPageNumber(0); // Reset to first page
//     fetchMeetings();
//   };

//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleEditClick = (meeting) => {
//     setEditingMeeting(meeting);
//     setShowMeetingForm(true);
//   };

//   const handleDeleteClick = (meeting) => {
//     setMeetingToDelete(meeting);
//     setShowDeleteModal(true);
//   };

//   const handleConfirmDelete = async () => {
//     if (!meetingToDelete) return;

//     try {
//       await axios.delete(
//         `${API_URL}/api/meetings/${meetingToDelete.meetingId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setMeetings((prev) =>
//         prev.filter((r) => r.meetingId !== meetingToDelete.meetingId)
//       );

//       setShowDeleteModal(false);
//       setMeetingToDelete(null);
//     } catch (error) {
//       console.error("Failed to delete meeting:", error);
//     }
//   };

//   const handleCancelDelete = () => {
//     setShowDeleteModal(false);
//     setMeetingToDelete(null);
//   };

//   const handleMeetingFormSubmit = async (formData) => {
//     try {
//       if (editingMeeting) {
//         await axios.put(
//           `${API_URL}/api/meetings/${editingMeeting.meetingId}`,
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );
//       } else {
//         await axios.post(`${API_URL}/api/meetings`, formData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//       }
//       fetchMeetings();
//       setShowMeetingForm(false);
//       setEditingMeeting(null);
//     } catch (error) {
//       console.error("Failed to submit meeting form:", error);
//     }
//   };

//   const handleKeyDown = useCallback((event) => {
//     const isEscape = event.key === "Escape";
//     const isAltC =
//       event.altKey &&
//       (event.key.toLowerCase() === "c" || event.key.toUpperCase() === "C");

//     if (isEscape || isAltC) {
//       setShowMeetingForm(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (showMeetingForm) {
//       document.addEventListener("keydown", handleKeyDown);
//     }
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [showMeetingForm, handleKeyDown]);

//   return (
//     <>
//       <div className="bg-gray-100 dark:bg-gray-900 p-2 rounded-lg shadow-lg">
//         <div className="p-2">
//           <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center">
//             <h2 className="text-xl font-bold">Meeting Table</h2>
//             {user?.accountType !== "COMPANY" && (
//               <div className="flex flex-wrap gap-1 sm:gap-2">
//                 <button
//                   className={`px-2 py-1 rounded ${
//                     activeTab === "assigned"
//                       ? "bg-blue-500 text-white"
//                       : "bg-gray-300"
//                   }`}
//                   onClick={() => setActiveTab("assigned")}
//                 >
//                   Assigned
//                 </button>
//                 <button
//                   className={`px-2 py-1 rounded ${
//                     activeTab === "createdBy"
//                       ? "bg-blue-500 text-white"
//                       : "bg-gray-300"
//                   }`}
//                   onClick={() => setActiveTab("createdBy")}
//                 >
//                   Created By
//                 </button>
//               </div>
//             )}
//             {/* Top Controls */}
//             <div className="flex flex-wrap justify-end gap-1 mb-3 sm:gap-2">
//               <button
//                 onClick={() => {
//                   setEditingMeeting(null);
//                   setShowMeetingForm(true);
//                 }}
//                 className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
//               >
//                 <PlusIcon className="w-5 h-5" />
//               </button>
//               <button
//                 onClick={() => setShowFields(!showFields)}
//                 className="px-2 py-1 bg-indigo-600 text-white hover:bg-indigo-700 rounded flex items-center"
//               >
//                 <FaSearch className="mr-2" />
//                 {showFields ? "Close" : "Search"}
//               </button>
//             </div>
//           </div>

//           {showFields && (
//             <form
//               onSubmit={handleSearchSubmit}
//               className="p-4 bg-white dark:bg-gray-800 rounded shadow mb-2 w-full"
//             >
//               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
//                 <div>
//                   <label className="block text-sm font-semibold mb-1">
//                     User
//                   </label>
//                   <select
//                     name="targetUserId"
//                     value={searchParams.targetUserId}
//                     onChange={handleSearchChange}
//                     className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="">All</option>
//                     {users.map((user) => (
//                       <option key={user.id} value={user.id}>
//                         {user.fname} {user.lname}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold mb-1">
//                     Meeting Type
//                   </label>
//                   <select
//                     name="meetingType"
//                     value={searchParams.meetingType}
//                     onChange={handleSearchChange}
//                     className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="">All</option>
//                     <option value="CALL">CALL</option>
//                     <option value="MEETING">MEETING</option>
//                     <option value="FOLLOW_UP">FOLLOW_UP</option>
//                   </select>
//                 </div>

//                 {[
//                   {
//                     label: "Message",
//                     name: "message",
//                     placeholder: "Search message",
//                   },
//                 ].map(({ label, name, placeholder }) => (
//                   <div key={name}>
//                     <label className="block text-sm font-semibold mb-1">
//                       {label}
//                     </label>
//                     <input
//                       type="text"
//                       name={name}
//                       value={searchParams[name]}
//                       onChange={handleSearchChange}
//                       placeholder={placeholder}
//                       className="w-full border rounded p-1 dark:bg-gray-700 dark:text-white"
//                     />
//                   </div>
//                 ))}
//               </div>

//               <div className="flex justify-end gap-2 mt-4">
//                 <button
//                   type="submit"
//                   className="px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center"
//                 >
//                   <FaSearch className="mr-2" /> Search
//                 </button>
//                 {isSearching && (
//                   <button
//                     type="button"
//                     onClick={handleClearSearch}
//                     className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
//                   >
//                     Clear
//                   </button>
//                 )}
//               </div>
//             </form>
//           )}
//         </div>

//         {/* Meeting Form Modal */}
//         {showMeetingForm && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl relative overflow-hidden">
//               {/* Header */}
//               <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 flex items-center justify-between border-b border-gray-200 dark:border-gray-700 px-5 py-4">
//                 <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
//                   {editingMeeting ? "Edit Meeting" : "Create Meeting"}
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setShowMeetingForm(false);
//                     setEditingMeeting(null);
//                   }}
//                   className="text-gray-500 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors"
//                   aria-label="Close modal"
//                 >
//                   <XMarkIcon className="w-6 h-6" />
//                 </button>
//               </div>

//               {/* Form Section */}
//               <div className="p-5 max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
//                 <MeetingForm
//                   initialData={editingMeeting}
//                   onSubmit={handleMeetingFormSubmit}
//                   onClose={() => {
//                     setShowMeetingForm(false);
//                     setEditingMeeting(null);
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Meeting Table */}
//         <div className="overflow-x-auto bg-white dark:bg-gray-800 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
//           <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-xs">
//             <thead className="bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
//               <tr>
//                 {[
//                   "S No.",
//                   "Date",
//                   "Time",
//                   "Message",
//                   "Type",
//                   "Emails",
//                   "Mobiles",
//                   "Assigned To",
//                   "Created By",
//                   ...(activeTab !== "assigned" || user?.accountType === "COMPANY" ? ["Actions"] : [])
//                 ].map((header) => (
//                   <th
//                     key={header}
//                     className="px-3 py-2 text-left font-semibold whitespace-nowrap"
//                   >
//                     {header}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-gray-800">
//               {meetings.length === 0 ? (
//                 <tr>
//                   <td
//                     colSpan={9}
//                     className="text-center py-6 text-gray-500 dark:text-gray-400"
//                   >
//                     No meetings found.
//                   </td>
//                 </tr>
//               ) : (
//                 meetings.map((meeting, index) => (
//                   <tr
//                     key={meeting.meetingId}
//                     className="hover:bg-gray-50 dark:hover:bg-gray-700 transition"
//                   >
//                     <td className="px-3 py-2">{index + 1}</td>
//                     <td className="px-3 py-2">{meeting.date || "_"}</td>
//                     <td className="px-3 py-2">{meeting.time || "_"}</td>
//                     <td className="px-3 py-2 whitespace-pre-wrap break-words max-w-xs">
//                       {meeting.message && meeting.message.length > 50 ? (
//                         <>
//                           {expandedMessages[meeting.meetingId]
//                             ? meeting.message
//                             : `${meeting.message.substring(0, 50)}...`}
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               toggleMessageExpansion(meeting.meetingId);
//                             }}
//                             className="ml-2 text-blue-600 hover:text-blue-800 text-sm"
//                           >
//                             {expandedMessages[meeting.meetingId]
//                               ? "View Less"
//                               : "View More"}
//                           </button>
//                         </>
//                       ) : (
//                         meeting.message || "_"
//                       )}
//                     </td>
//                     <td className="px-3 py-2">{meeting.meetingType || "_"}</td>
//                     <td className="px-3 py-2">
//                       {(meeting.email || []).join(", ") || "_"}
//                     </td>
//                     <td className="px-3 py-2">
//                       {(meeting.mobileNo || []).join(", ") || "_"}
//                     </td>
//                     <td className="px-3 py-2 whitespace-pre-line">
//                       {meeting.assignedTo && meeting.assignedTo.length > 0 ? (
//                         meeting.assignedTo.map((person) => (
//                           <div
//                             key={person.id}
//                             className="text-gray-800 dark:text-gray-200"
//                           >
//                             {" "}
//                             {person.name}
//                           </div>
//                         ))
//                       ) : (
//                         <span className="italic text-gray-400">_</span>
//                       )}
//                     </td>
//                     <td className="px-3 py-2">
//                       {meeting.createdByName || "_"}
//                     </td>
//                    {(user?.accountType === "COMPANY" || (activeTab && activeTab !== "assigned" && activeTab === "createdBy")) && (
//                     <td className="px-3 py-2">
//                       <div className="flex items-center space-x-2">
//                         <button
//                           onClick={() => handleEditClick(meeting)}
//                           className="text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
//                           aria-label="Edit Meeting"
//                         >
//                           <FaEdit />
//                         </button>
//                         <button
//                           onClick={() => handleDeleteClick(meeting)}
//                           className="text-red-600 hover:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-500 rounded"
//                           aria-label="Delete Meeting"
//                         >
//                           <FaTrash />
//                         </button>
//                       </div>
//                     </td>
//                     )}
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {totalPages > 0 && (
//   <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4">
//     <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
//       <span className="text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">
//         Items per page:
//       </span>
//       <Select
//         className="w-24 text-sm"
//         value={pageSize}
//         onChange={(value) => {
//           const newPageSize = Number(value);
//           setPageSize(newPageSize);
//           setPageNumber(0);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           } else {
//             fetchMeetings();
//           }
//         }}
//         options={[
//           { value: 5, label: "5" },
//           { value: 10, label: "10" },
//           { value: 20, label: "20" },
//           { value: 50, label: "50" },
//         ]}
//         styles={{
//           control: (base) => ({
//             ...base,
//             minHeight: "32px",
//             fontSize: "0.875rem",
//           }),
//         }}
//       />
//     </div>

//     <div className="flex items-center gap-1 sm:gap-3 flex-wrap justify-center w-full sm:w-auto">
//       {/* First Page Button */}
//       <button
//         onClick={() => {
//           setPageNumber(0);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[60px]"
//         disabled={pageNumber === 0}
//         title="First Page"
//       >
//         First
//       </button>

//       <button
//         onClick={() => {
//           const newPage = Math.max(pageNumber - 1, 0);
//           setPageNumber(newPage);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[50px]"
//         disabled={pageNumber === 0}
//         title="Previous Page"
//       >
//         Prev
//       </button>

//       <span className="text-sm font-medium px-2 sm:px-0">
//         Page {pageNumber + 1} of {totalPages}
//       </span>

//       <button
//         onClick={() => {
//           const newPage = Math.min(pageNumber + 1, totalPages - 1);
//           setPageNumber(newPage);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[50px]"
//         disabled={pageNumber >= totalPages - 1}
//         title="Next Page"
//       >
//         Next
//       </button>

//       {/* Last Page Button */}
//       <button
//         onClick={() => {
//           setPageNumber(totalPages - 1);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[60px]"
//         disabled={pageNumber >= totalPages - 1}
//         title="Last Page"
//       >
//         Last
//       </button>
//     </div>
//   </div>
// )}

//         {showDeleteModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full shadow-lg">
//               <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white">
//                 Confirm Deletion
//               </h2>
//               <p className="mb-6 text-gray-700 dark:text-gray-300">
//                 Are you sure you want to delete this meeting?
//               </p>
//               <div className="flex justify-end gap-3">
//                 <button
//                   onClick={handleCancelDelete}
//                   className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleConfirmDelete}
//                   className="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded"
//                 >
//                   Confirm
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }




// import { useState, useEffect, useContext, useCallback } from "react";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
// import MeetingForm from "./MeetingForm";
// import { FaEdit, FaSearch, FaTrash } from "react-icons/fa";
// import { Select } from "antd";

// export default function Meeting() {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [meetings, setMeetings] = useState([]);
//   const [showMeetingForm, setShowMeetingForm] = useState(false);
//   const [editingMeeting, setEditingMeeting] = useState(null);
//   const [activeTab, setActiveTab] = useState("assigned");
//   const [searchParams, setSearchParams] = useState({
//     targetUserId: "",
//     meetingType: "",
//     message: "",
//   });
//   const [isSearching, setIsSearching] = useState(false);
//   const [showFields, setShowFields] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [meetingToDelete, setMeetingToDelete] = useState(null);
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
//   const [expandedMessages, setExpandedMessages] = useState({});

//   const toggleMessageExpansion = (meetingId) => {
//     setExpandedMessages((prev) => ({
//       ...prev,
//       [meetingId]: !prev[meetingId],
//     }));
//   };

//   // Fetch meetings based on account type
//   const fetchMeetings = useCallback(async () => {
//     try {
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/meetings/company/${user.id}`
//           : activeTab === "assigned"
//           ? `${API_URL}/api/meetings/assigned/${user.id}`
//           : `${API_URL}/api/meetings/createdBy/${user.id}`;

//       const response = await axios.get(
//         `${url}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setMeetings(response.data?.meetings || []);
//       setTotalPages(response.data?.totalPages || 0);
//     } catch (error) {
//       console.error("Error fetching reminders:", error);
//       setMeetings([]);
//       setTotalPages(0);
//     }
//   }, [user, activeTab, pageNumber, pageSize]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchMeetings();
//     }
//   }, [user, activeTab, pageNumber, fetchMeetings]);

//   useEffect(() => {
//     const handleMeetingCreated = () => {
//       // Your data fetching logic here
//       fetchMeetings();
//     };

//     window.addEventListener("meetingCreated", handleMeetingCreated);

//     return () => {
//       window.removeEventListener("meetingCreated", handleMeetingCreated);
//     };
//   }, []);

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;

//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await axios.get(url, {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         setUsers(response.data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);

//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       const params = {
//         pageNumber: 0, // Always start from first page when searching
//         pageSize: pageSize,
//         ...Object.fromEntries(
//           Object.entries(searchParams).filter(([_, v]) => v !== "")
//         ),
//       };

//       const response = await axios.get(
//         `${API_URL}/api/meetings/search/${companyId}/${user?.id}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setMeetings(response.data?.meetings || []);
//       setTotalPages(response.data?.totalPages || 0);
//       setPageNumber(0); // Reset to first page after search
//     } catch (error) {
//       console.error("Failed to search meetings:", error);
//       setMeetings([]);
//       setTotalPages(0);
//     }
//   };

//   const handleClearSearch = async () => {
//     setIsSearching(false);
//     setSearchParams({
//       targetUserId: "",
//       meetingType: "",
//       message: "",
//     });
//     setPageNumber(0); // Reset to first page
//     fetchMeetings();
//   };

//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleEditClick = (meeting) => {
//     setEditingMeeting(meeting);
//     setShowMeetingForm(true);
//   };

//   const handleDeleteClick = (meeting) => {
//     setMeetingToDelete(meeting);
//     setShowDeleteModal(true);
//   };

//   const handleConfirmDelete = async () => {
//     if (!meetingToDelete) return;

//     try {
//       await axios.delete(
//         `${API_URL}/api/meetings/${meetingToDelete.meetingId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setMeetings((prev) =>
//         prev.filter((r) => r.meetingId !== meetingToDelete.meetingId)
//       );

//       setShowDeleteModal(false);
//       setMeetingToDelete(null);
//     } catch (error) {
//       console.error("Failed to delete meeting:", error);
//     }
//   };

//   const handleCancelDelete = () => {
//     setShowDeleteModal(false);
//     setMeetingToDelete(null);
//   };

//   const handleMeetingFormSubmit = async (formData) => {
//     try {
//       if (editingMeeting) {
//         await axios.put(
//           `${API_URL}/api/meetings/${editingMeeting.meetingId}`,
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );
//       } else {
//         await axios.post(`${API_URL}/api/meetings`, formData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//       }
//       fetchMeetings();
//       setShowMeetingForm(false);
//       setEditingMeeting(null);
//     } catch (error) {
//       console.error("Failed to submit meeting form:", error);
//     }
//   };

//   const handleKeyDown = useCallback((event) => {
//     const isEscape = event.key === "Escape";
//     const isAltC =
//       event.altKey &&
//       (event.key.toLowerCase() === "c" || event.key.toUpperCase() === "C");

//     if (isEscape || isAltC) {
//       setShowMeetingForm(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (showMeetingForm) {
//       document.addEventListener("keydown", handleKeyDown);
//     }
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [showMeetingForm, handleKeyDown]);

//   return (
//     <>
//       <div className="bg-gray-100 dark:bg-gray-900 p-2 rounded-lg shadow-lg">
//         <div className="p-2">
//           <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center">
//             <h2 className="text-xl font-bold">Meeting Table</h2>
//             {user?.accountType !== "COMPANY" && (
//               <div className="flex flex-wrap gap-1 sm:gap-2">
//                 <button
//                   className={`px-2 py-1 rounded ${
//                     activeTab === "assigned"
//                       ? "bg-blue-500 text-white"
//                       : "bg-gray-300"
//                   }`}
//                   onClick={() => setActiveTab("assigned")}
//                 >
//                   Assigned
//                 </button>
//                 <button
//                   className={`px-2 py-1 rounded ${
//                     activeTab === "createdBy"
//                       ? "bg-blue-500 text-white"
//                       : "bg-gray-300"
//                   }`}
//                   onClick={() => setActiveTab("createdBy")}
//                 >
//                   Created By
//                 </button>
//               </div>
//             )}
//             {/* Top Controls */}
//             <div className="flex flex-wrap justify-end gap-1 mb-3 sm:gap-2">
//               <button
//                 onClick={() => {
//                   setEditingMeeting(null);
//                   setShowMeetingForm(true);
//                 }}
//                 className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
//               >
//                 <PlusIcon className="w-5 h-5" />
//               </button>
//               <button
//                 onClick={() => setShowFields(!showFields)}
//                 className="px-2 py-1 bg-indigo-600 text-white hover:bg-indigo-700 rounded flex items-center"
//               >
//                 <FaSearch className="mr-2" />
//                 {showFields ? "Close" : "Search"}
//               </button>
//             </div>
//           </div>

//           {showFields && (
//             <form
//               onSubmit={handleSearchSubmit}
//               className="p-4 bg-white dark:bg-gray-800 rounded shadow mb-2 w-full"
//             >
//               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
//                 <div>
//                   <label className="block text-sm font-semibold mb-1">
//                     User
//                   </label>
//                   <select
//                     name="targetUserId"
//                     value={searchParams.targetUserId}
//                     onChange={handleSearchChange}
//                     className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="">All</option>
//                     {users.map((user) => (
//                       <option key={user.id} value={user.id}>
//                         {user.fname} {user.lname}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold mb-1">
//                     Meeting Type
//                   </label>
//                   <select
//                     name="meetingType"
//                     value={searchParams.meetingType}
//                     onChange={handleSearchChange}
//                     className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="">All</option>
//                     <option value="CALL">CALL</option>
//                     <option value="MEETING">MEETING</option>
//                     <option value="FOLLOW_UP">FOLLOW_UP</option>
//                   </select>
//                 </div>

//                 {[
//                   {
//                     label: "Message",
//                     name: "message",
//                     placeholder: "Search message",
//                   },
//                 ].map(({ label, name, placeholder }) => (
//                   <div key={name}>
//                     <label className="block text-sm font-semibold mb-1">
//                       {label}
//                     </label>
//                     <input
//                       type="text"
//                       name={name}
//                       value={searchParams[name]}
//                       onChange={handleSearchChange}
//                       placeholder={placeholder}
//                       className="w-full border rounded p-1 dark:bg-gray-700 dark:text-white"
//                     />
//                   </div>
//                 ))}
//               </div>

//               <div className="flex justify-end gap-2 mt-4">
//                 <button
//                   type="submit"
//                   className="px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center"
//                 >
//                   <FaSearch className="mr-2" /> Search
//                 </button>
//                 {isSearching && (
//                   <button
//                     type="button"
//                     onClick={handleClearSearch}
//                     className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
//                   >
//                     Clear
//                   </button>
//                 )}
//               </div>
//             </form>
//           )}
//         </div>

//         {/* Meeting Form Modal */}
//         {showMeetingForm && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl relative overflow-hidden">
//               {/* Header */}
//               <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 flex items-center justify-between border-b border-gray-200 dark:border-gray-700 px-5 py-4">
//                 <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
//                   {editingMeeting ? "Edit Meeting" : "Create Meeting"}
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setShowMeetingForm(false);
//                     setEditingMeeting(null);
//                   }}
//                   className="text-gray-500 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors"
//                   aria-label="Close modal"
//                 >
//                   <XMarkIcon className="w-6 h-6" />
//                 </button>
//               </div>

//               {/* Form Section */}
//               <div className="p-5 max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
//                 <MeetingForm
//                   initialData={editingMeeting}
//                   onSubmit={handleMeetingFormSubmit}
//                   onClose={() => {
//                     setShowMeetingForm(false);
//                     setEditingMeeting(null);
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Meeting Table */}
//         <div className="overflow-x-auto bg-white dark:bg-gray-800 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
//           <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-xs">
//             <thead className="bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
//               <tr>
//                 {[
//                   "S No.",
//                   "Date",
//                   "Time",
//                   "Message",
//                   "Type",
//                   "Emails",
//                   "Mobiles",
//                   "Assigned To",
//                   "Created By",
//                   ...(activeTab !== "assigned" || user?.accountType === "COMPANY" ? ["Actions"] : [])
//                 ].map((header) => (
//                   <th
//                     key={header}
//                     className="px-3 py-2 text-left font-semibold whitespace-nowrap"
//                   >
//                     {header}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-gray-800">
//               {meetings.length === 0 ? (
//                 <tr>
//                   <td
//                     colSpan={9}
//                     className="text-center py-6 text-gray-500 dark:text-gray-400"
//                   >
//                     No meetings found.
//                   </td>
//                 </tr>
//               ) : (
//                 meetings.map((meeting, index) => (
//                   <tr
//                     key={meeting.meetingId}
//                     className="hover:bg-gray-50 dark:hover:bg-gray-700 transition"
//                   >
//                     <td className="px-3 py-2">{index + 1}</td>
//                     <td className="px-3 py-2">{meeting.date || "_"}</td>
//                     <td className="px-3 py-2">{meeting.time || "_"}</td>
//                     <td className="px-3 py-2 whitespace-pre-wrap break-words max-w-xs">
//                       {meeting.message && meeting.message.length > 50 ? (
//                         <>
//                           {expandedMessages[meeting.meetingId]
//                             ? meeting.message
//                             : `${meeting.message.substring(0, 50)}...`}
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               toggleMessageExpansion(meeting.meetingId);
//                             }}
//                             className="ml-2 text-blue-600 hover:text-blue-800 text-sm"
//                           >
//                             {expandedMessages[meeting.meetingId]
//                               ? "View Less"
//                               : "View More"}
//                           </button>
//                         </>
//                       ) : (
//                         meeting.message || "_"
//                       )}
//                     </td>
//                     <td className="px-3 py-2">{meeting.meetingType || "_"}</td>
//                     <td className="px-3 py-2">
//                       {(meeting.email || []).join(", ") || "_"}
//                     </td>
//                     <td className="px-3 py-2">
//                       {(meeting.mobileNo || []).join(", ") || "_"}
//                     </td>
//                     <td className="px-3 py-2 whitespace-pre-line">
//                       {meeting.assignedTo && meeting.assignedTo.length > 0 ? (
//                         meeting.assignedTo.map((person) => (
//                           <div
//                             key={person.id}
//                             className="text-gray-800 dark:text-gray-200"
//                           >
//                             {" "}
//                             {person.name}
//                           </div>
//                         ))
//                       ) : (
//                         <span className="italic text-gray-400">_</span>
//                       )}
//                     </td>
//                     <td className="px-3 py-2">
//                       {meeting.createdByName || "_"}
//                     </td>
//                    {(user?.accountType === "COMPANY" || (activeTab && activeTab !== "assigned" && activeTab === "createdBy")) && (
//                     <td className="px-3 py-2">
//                       <div className="flex items-center space-x-2">
//                         <button
//                           onClick={() => handleEditClick(meeting)}
//                           className="text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
//                           aria-label="Edit Meeting"
//                         >
//                           <FaEdit />
//                         </button>
//                         <button
//                           onClick={() => handleDeleteClick(meeting)}
//                           className="text-red-600 hover:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-500 rounded"
//                           aria-label="Delete Meeting"
//                         >
//                           <FaTrash />
//                         </button>
//                       </div>
//                     </td>
//                     )}
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {totalPages > 0 && (
//   <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4">
//     <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
//       <span className="text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">
//         Items per page:
//       </span>
//       <Select
//         className="w-24 text-sm"
//         value={pageSize}
//         onChange={(value) => {
//           const newPageSize = Number(value);
//           setPageSize(newPageSize);
//           setPageNumber(0);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           } else {
//             fetchMeetings();
//           }
//         }}
//         options={[
//           { value: 5, label: "5" },
//           { value: 10, label: "10" },
//           { value: 20, label: "20" },
//           { value: 50, label: "50" },
//         ]}
//         styles={{
//           control: (base) => ({
//             ...base,
//             minHeight: "32px",
//             fontSize: "0.875rem",
//           }),
//         }}
//       />
//     </div>

//     <div className="flex items-center gap-1 sm:gap-3 flex-wrap justify-center w-full sm:w-auto">
//       {/* First Page Button */}
//       <button
//         onClick={() => {
//           setPageNumber(0);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[60px]"
//         disabled={pageNumber === 0}
//         title="First Page"
//       >
//         First
//       </button>

//       <button
//         onClick={() => {
//           const newPage = Math.max(pageNumber - 1, 0);
//           setPageNumber(newPage);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[50px]"
//         disabled={pageNumber === 0}
//         title="Previous Page"
//       >
//         Prev
//       </button>

//       <span className="text-sm font-medium px-2 sm:px-0">
//         Page {pageNumber + 1} of {totalPages}
//       </span>

//       <button
//         onClick={() => {
//           const newPage = Math.min(pageNumber + 1, totalPages - 1);
//           setPageNumber(newPage);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[50px]"
//         disabled={pageNumber >= totalPages - 1}
//         title="Next Page"
//       >
//         Next
//       </button>

//       {/* Last Page Button */}
//       <button
//         onClick={() => {
//           setPageNumber(totalPages - 1);
//           if (isSearching) {
//             handleSearchSubmit({ preventDefault: () => {} });
//           }
//         }}
//         className="px-2 sm:px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 min-w-[60px]"
//         disabled={pageNumber >= totalPages - 1}
//         title="Last Page"
//       >
//         Last
//       </button>
//     </div>
//   </div>
// )}

//         {showDeleteModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full shadow-lg">
//               <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white">
//                 Confirm Deletion
//               </h2>
//               <p className="mb-6 text-gray-700 dark:text-gray-300">
//                 Are you sure you want to delete this meeting?
//               </p>
//               <div className="flex justify-end gap-3">
//                 <button
//                   onClick={handleCancelDelete}
//                   className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleConfirmDelete}
//                   className="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded"
//                 >
//                   Confirm
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }





import { useState, useEffect, useContext, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
import MeetingForm from "./MeetingForm";
import { FaEdit, FaSearch, FaTrash } from "react-icons/fa";
import { Select } from "antd";

export default function Meeting() {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [editingMeeting, setEditingMeeting] = useState(null);
  const [activeTab, setActiveTab] = useState("assigned");
  const [searchParams, setSearchParams] = useState({
    targetUserId: "",
    meetingType: "",
    message: "",
  });
  const [isSearching, setIsSearching] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [meetingToDelete, setMeetingToDelete] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [expandedMessages, setExpandedMessages] = useState({});

  const toggleMessageExpansion = (meetingId) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [meetingId]: !prev[meetingId],
    }));
  };

  // Fetch meetings based on account type
  const fetchMeetings = useCallback(async () => {
    try {
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/meetings/company/${user.id}`
          : activeTab === "assigned"
          ? `${API_URL}/api/meetings/assigned/${user.id}`
          : `${API_URL}/api/meetings/createdBy/${user.id}`;

      const response = await axios.get(
        `${url}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      setMeetings(response.data?.meetings || []);
      setTotalPages(response.data?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching reminders:", error);
      setMeetings([]);
      setTotalPages(0);
    }
  }, [user, activeTab, pageNumber, pageSize]);

  useEffect(() => {
    if (user?.id) {
      fetchMeetings();
    }
  }, [user, activeTab, pageNumber, fetchMeetings]);

  useEffect(() => {
    const handleMeetingCreated = () => {
      // Your data fetching logic here
      fetchMeetings();
    };

    window.addEventListener("meetingCreated", handleMeetingCreated);

    return () => {
      window.removeEventListener("meetingCreated", handleMeetingCreated);
    };
  }, []);

  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;

      const url =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await axios.get(url, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setIsSearching(true);

    try {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return;

      const params = {
        pageNumber: 0, // Always start from first page when searching
        pageSize: pageSize,
        ...Object.fromEntries(
          Object.entries(searchParams).filter(([_, v]) => v !== "")
        ),
      };

      const response = await axios.get(
        `${API_URL}/api/meetings/search/${companyId}/${user?.id}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMeetings(response.data?.meetings || []);
      setTotalPages(response.data?.totalPages || 0);
      setPageNumber(0); // Reset to first page after search
    } catch (error) {
      console.error("Failed to search meetings:", error);
      setMeetings([]);
      setTotalPages(0);
    }
  };

  const handleClearSearch = async () => {
    setIsSearching(false);
    setSearchParams({
      targetUserId: "",
      meetingType: "",
      message: "",
    });
    setPageNumber(0); // Reset to first page
    fetchMeetings();
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (meeting) => {
    setEditingMeeting(meeting);
    setShowMeetingForm(true);
  };

  const handleDeleteClick = (meeting) => {
    setMeetingToDelete(meeting);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!meetingToDelete) return;

    try {
      await axios.delete(
        `${API_URL}/api/meetings/${meetingToDelete.meetingId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMeetings((prev) =>
        prev.filter((r) => r.meetingId !== meetingToDelete.meetingId)
      );

      setShowDeleteModal(false);
      setMeetingToDelete(null);
    } catch (error) {
      console.error("Failed to delete meeting:", error);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setMeetingToDelete(null);
  };

  const handleMeetingFormSubmit = async (formData) => {
    try {
      if (editingMeeting) {
        await axios.put(
          `${API_URL}/api/meetings/${editingMeeting.meetingId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        await axios.post(`${API_URL}/api/meetings`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
      }
      fetchMeetings();
      setShowMeetingForm(false);
      setEditingMeeting(null);
    } catch (error) {
      console.error("Failed to submit meeting form:", error);
    }
  };

  const handleKeyDown = useCallback((event) => {
    const isEscape = event.key === "Escape";
    const isAltC =
      event.altKey &&
      (event.key.toLowerCase() === "c" || event.key.toUpperCase() === "C");

    if (isEscape || isAltC) {
      setShowMeetingForm(false);
    }
  }, []);

  useEffect(() => {
    if (showMeetingForm) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showMeetingForm, handleKeyDown]);

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      <div className="bg-[#FAF8FF] dark:bg-gray-900 p-2 rounded-lg shadow-lg cfg-font min-h-screen">
        <div className="p-4">
          <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center">
            <h2 className="text-xl font-bold cfg-heading dark:text-white">Meeting Table</h2>
            {user?.accountType !== "COMPANY" && (
              <div className="flex flex-wrap gap-1 sm:gap-2">
                <button
                  className={`px-3 py-1.5 rounded-md font-medium text-sm transition ${
                    activeTab === "assigned"
                      ? "bg-[#673AB7] text-white shadow-md"
                      : "bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600"
                  }`}
                  onClick={() => setActiveTab("assigned")}
                >
                  Assigned
                </button>
                <button
                  className={`px-3 py-1.5 rounded-md font-medium text-sm transition ${
                    activeTab === "createdBy"
                      ? "bg-[#673AB7] text-white shadow-md"
                      : "bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600"
                  }`}
                  onClick={() => setActiveTab("createdBy")}
                >
                  Created By
                </button>
              </div>
            )}
            {/* Top Controls */}
            <div className="flex flex-wrap justify-end gap-2 mb-3 sm:gap-2">
              <button
                onClick={() => {
                  setEditingMeeting(null);
                  setShowMeetingForm(true);
                }}
                className="px-3 py-1.5 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-sm transition flex items-center justify-center"
              >
                <PlusIcon className="w-5 h-5" />
              </button>
              <button
                onClick={() => setShowFields(!showFields)}
                className="px-3 py-1.5 bg-[#673AB7] text-white hover:bg-[#5E35A6] rounded-md shadow-sm flex items-center transition"
              >
                <FaSearch className="mr-2" />
                {showFields ? "Close" : "Search"}
              </button>
            </div>
          </div>

          {showFields && (
            <form
              onSubmit={handleSearchSubmit}
              className="p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-[#E5E7EB] dark:border-gray-700 mb-4 w-full"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 items-end">
                <div>
                  <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                    User
                  </label>
                  <select
                    name="targetUserId"
                    value={searchParams.targetUserId}
                    onChange={handleSearchChange}
                    className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                  >
                    <option value="">All</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.fname} {user.lname}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                    Meeting Type
                  </label>
                  <select
                    name="meetingType"
                    value={searchParams.meetingType}
                    onChange={handleSearchChange}
                    className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                  >
                    <option value="">All</option>
                    <option value="CALL">CALL</option>
                    <option value="MEETING">MEETING</option>
                    <option value="FOLLOW_UP">FOLLOW_UP</option>
                  </select>
                </div>

                {[
                  {
                    label: "Message",
                    name: "message",
                    placeholder: "Search message",
                  },
                ].map(({ label, name, placeholder }) => (
                  <div key={name}>
                    <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                      {label}
                    </label>
                    <input
                      type="text"
                      name={name}
                      value={searchParams[name]}
                      onChange={handleSearchChange}
                      placeholder={placeholder}
                      className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                    />
                  </div>
                ))}
              </div>

              <div className="flex justify-end gap-2 mt-3">
                <button
                  type="submit"
                  className="px-3 py-1.5 text-xs bg-[#673AB7] text-white font-medium rounded-md hover:bg-[#5E35A6] shadow-sm transition flex items-center"
                >
                  <FaSearch className="mr-1.5" /> Search
                </button>
                {isSearching && (
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    className="px-3 py-1.5 text-xs bg-[#F3F4F6] text-[#374151] font-medium rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600"
                  >
                    Clear
                  </button>
                )}
              </div>
            </form>
          )}
        </div>

        {/* Meeting Form Modal */}
        {showMeetingForm && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl relative overflow-hidden border border-[#E5E7EB] dark:border-gray-700">
              {/* Header */}
              <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 flex items-center justify-between border-b border-[#E5E7EB] dark:border-gray-700 px-5 py-4">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                  {editingMeeting ? "Edit Meeting" : "Create Meeting"}
                </h2>
                <button
                  onClick={() => {
                    setShowMeetingForm(false);
                    setEditingMeeting(null);
                  }}
                  className="text-[#6B7280] dark:text-gray-300 hover:text-[#EF4444] dark:hover:text-[#FCA5A5] transition-colors"
                  aria-label="Close modal"
                >
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>

              {/* Form Section */}
              <div className="p-5 max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <MeetingForm
                  initialData={editingMeeting}
                  onSubmit={handleMeetingFormSubmit}
                  onClose={() => {
                    setShowMeetingForm(false);
                    setEditingMeeting(null);
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Meeting Table */}
        <div className="overflow-x-auto bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-[#E5E7EB] dark:border-gray-700 mx-4">
          <table className="min-w-full divide-y divide-[#E5E7EB] dark:divide-gray-700 text-sm">
            <thead className="bg-[#F3F4F6] dark:bg-gray-700 text-[#6B7280] dark:text-gray-300 uppercase tracking-wider text-xs">
              <tr>
                {[
                  "S No.",
                  "Date",
                  "Time",
                  "Message",
                  "Type",
                  "Emails",
                  "Mobiles",
                  "Assigned To",
                  "Created By",
                  ...(activeTab !== "assigned" || user?.accountType === "COMPANY" ? ["Actions"] : [])
                ].map((header) => (
                  <th
                    key={header}
                    className="px-3 py-3 text-left font-semibold whitespace-nowrap border-b border-[#E5E7EB] dark:border-gray-600"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E5E7EB] dark:divide-gray-700 bg-white dark:bg-gray-800">
              {meetings.length === 0 ? (
                <tr>
                  <td
                    colSpan={10}
                    className="text-center py-8 text-[#6B7280] dark:text-gray-400"
                  >
                    No meetings found.
                  </td>
                </tr>
              ) : (
                meetings.map((meeting, index) => (
                  <tr
                    key={meeting.meetingId}
                    className="hover:bg-[#FAF8FF] dark:hover:bg-gray-700 transition-colors text-[#374151] dark:text-gray-200"
                  >
                    <td className="px-3 py-3 font-medium">{pageNumber * pageSize + index + 1}</td>
                    <td className="px-3 py-3">{meeting.date || "_"}</td>
                    <td className="px-3 py-3">{meeting.time || "_"}</td>
                    <td className="px-3 py-3 whitespace-pre-wrap break-words max-w-xs">
                      {meeting.message && meeting.message.length > 50 ? (
                        <>
                          {expandedMessages[meeting.meetingId]
                            ? meeting.message
                            : `${meeting.message.substring(0, 50)}...`}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleMessageExpansion(meeting.meetingId);
                            }}
                            className="ml-2 text-[#8B5CF6] hover:text-[#673AB7] font-semibold text-xs transition"
                          >
                            {expandedMessages[meeting.meetingId]
                              ? "View Less"
                              : "View More"}
                          </button>
                        </>
                      ) : (
                        meeting.message || "_"
                      )}
                    </td>
                    <td className="px-3 py-3 font-medium">
                      <span className="bg-[#F3F4F6] dark:bg-gray-600 px-2 py-1 rounded text-xs">
                        {meeting.meetingType || "_"}
                      </span>
                    </td>
                    <td className="px-3 py-3">
                      {(meeting.email || []).join(", ") || "_"}
                    </td>
                    <td className="px-3 py-3">
                      {(meeting.mobileNo || []).join(", ") || "_"}
                    </td>
                    <td className="px-3 py-3 whitespace-pre-line">
                      {meeting.assignedTo && meeting.assignedTo.length > 0 ? (
                        meeting.assignedTo.map((person) => (
                          <div
                            key={person.id}
                            className="text-[#374151] dark:text-gray-200"
                          >
                            {person.name}
                          </div>
                        ))
                      ) : (
                        <span className="italic text-[#6B7280]">_</span>
                      )}
                    </td>
                    <td className="px-3 py-3">
                      {meeting.createdByName || "_"}
                    </td>
                    {(user?.accountType === "COMPANY" || (activeTab && activeTab !== "assigned" && activeTab === "createdBy")) && (
                    <td className="px-3 py-3">
                      <div className="flex items-center space-x-3">
                        <button
                          onClick={() => handleEditClick(meeting)}
                          className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-base transition-colors focus:outline-none"
                          aria-label="Edit Meeting"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDeleteClick(meeting)}
                          className="text-[#EF4444] hover:text-[#B91C1C] dark:hover:text-[#FCA5A5] text-base transition-colors focus:outline-none"
                          aria-label="Delete Meeting"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 0 && (
          <div className="mx-4 mt-4 flex flex-col sm:flex-row justify-between items-center gap-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-700 shadow-sm">
            <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
              <span className="text-sm text-[#374151] dark:text-gray-300 whitespace-nowrap">
                Items per page:
              </span>
              <Select
                className="w-20 sm:w-24 text-sm"
                value={pageSize}
                onChange={(value) => {
                  const newPageSize = Number(value);
                  setPageSize(newPageSize);
                  setPageNumber(0);
                  if (isSearching) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  } else {
                    fetchMeetings();
                  }
                }}
                options={[
                  { value: 5, label: "5" },
                  { value: 10, label: "10" },
                  { value: 20, label: "20" },
                  { value: 50, label: "50" },
                ]}
                styles={{
                  control: (baseStyles, state) => {
                    const isDark =
                      typeof window !== "undefined" &&
                      document.documentElement.classList.contains("dark");
                    return {
                      ...baseStyles,
                      backgroundColor: isDark ? "#374151" : "#ffffff",
                      color: isDark ? "#ffffff" : "#000000",
                      borderColor: isDark ? "#4b5563" : "#E5E7EB",
                      minHeight: "32px",
                      fontSize: "0.875rem",
                      zIndex: 10,
                    };
                  },
                  singleValue: (base) => {
                    const isDark =
                      typeof window !== "undefined" &&
                      document.documentElement.classList.contains("dark");
                    return {
                      ...base,
                      color: isDark ? "#ffffff" : "#374151",
                    };
                  },
                  menu: (base) => {
                    const isDark =
                      typeof window !== "undefined" &&
                      document.documentElement.classList.contains("dark");
                    return {
                      ...base,
                      backgroundColor: isDark ? "#1f2937" : "#ffffff",
                      color: isDark ? "#ffffff" : "#000000",
                      zIndex: 9999,
                    };
                  },
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => {
                    const isDark =
                      typeof window !== "undefined" &&
                      document.documentElement.classList.contains("dark");
                    return {
                      ...base,
                      backgroundColor: state.isFocused
                        ? isDark
                          ? "#4b5563"
                          : "#F3F4F6"
                        : isDark
                        ? "#1f2937"
                        : "#ffffff",
                      color: isDark ? "#ffffff" : "#374151",
                      cursor: "pointer",
                    };
                  },
                }}
              />
            </div>

            <div className="flex items-center gap-2 flex-wrap justify-center w-full sm:w-auto">
              <button
                onClick={() => {
                  setPageNumber(0);
                  if (isSearching) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  }
                }}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber === 0}
                title="First Page"
              >
                First
              </button>

              <button
                onClick={() => {
                  const newPage = Math.max(pageNumber - 1, 0);
                  setPageNumber(newPage);
                  if (isSearching) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  }
                }}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber === 0}
                title="Previous Page"
              >
                Prev
              </button>

              <span className="text-sm font-medium px-2 text-[#374151] dark:text-gray-300">
                Page {pageNumber + 1} of {totalPages}
              </span>

              <button
                onClick={() => {
                  const newPage = Math.min(pageNumber + 1, totalPages - 1);
                  setPageNumber(newPage);
                  if (isSearching) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  }
                }}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber >= totalPages - 1}
                title="Next Page"
              >
                Next
              </button>

              <button
                onClick={() => {
                  setPageNumber(totalPages - 1);
                  if (isSearching) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  }
                }}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                disabled={pageNumber >= totalPages - 1}
                title="Last Page"
              >
                Last
              </button>
            </div>
          </div>
        )}

        {showDeleteModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 max-w-sm w-full shadow-2xl border border-[#E5E7EB] dark:border-gray-700 transform transition-all scale-100">
              <h2 className="text-xl font-bold mb-3 cfg-heading text-[#1F2937] dark:text-white">
                Confirm Deletion
              </h2>
              <p className="mb-6 text-[#374151] dark:text-gray-300 text-sm">
                Are you sure you want to delete this meeting? This action cannot be undone.
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={handleCancelDelete}
                  className="px-4 py-2 font-semibold text-[#374151] bg-[#F3F4F6] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmDelete}
                  className="px-4 py-2 font-semibold bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}